import { Component, Input, OnInit, signal } from "@angular/core";
import * as Highcharts from "highcharts/highstock";
import { HighchartsChartComponent } from "highcharts-angular";

import { HC_COLORS } from "../highcharts-shared";

@Component({
  selector: "app-industry-bar-chart",
  templateUrl: "./industry-bar-chart.component.html",
  styleUrls: ["./industry-bar-chart.component.scss"],
  imports: [HighchartsChartComponent],
  standalone: true,
})
export class IndustryBarChartComponent implements OnInit {
  @Input() dataRaw: any[] = [];
  @Input() subHeader: any = {};
  loaded = signal(false);

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "chart";
  chartOptions: Highcharts.Options = {};

  ngOnInit(): void {
    this.initChart();
  }

  initChart() {
    this.loaded.set(false);

    this.chartOptions = {
      chart: {
        height: "500px",
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      tooltip: {
        valueSuffix: "%",
      },
      yAxis: {
        minorGridLineWidth: 0,
        min: 0,
        title: {
          text: "",
        },
        labels: {
          format: "{value}%",
        },
      },
      xAxis: {
        categories: Object.keys(this.dataRaw),
        gridLineWidth: 0,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: "{y}%",
          },
        },
      },
      colors: [HC_COLORS.accent],
      series: [
        {
          type: "column",
          name: "Industry",
          data: Object.values(this.dataRaw),
        },
      ],
    };
    setTimeout(() => {
      this.loaded.set(true);
    });
  }
}
